import { useMemo } from "react";

import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { SelectedOrganizationIdGenerator } from "@/Common/Api/MedfarDictionaries/Dto/Responses/SelectedOrganizationIdGenerator";
import { FilteredOrganizationRules } from "@/Common/Utilities/FilteredOrganizationRules";
import { useTitleValidation } from "./useTitleValidation";

/**
 * Generates the unique id for the selected User's Licence Organization Rule
 * @param filteredOrganizationRules Contains the list of valid Licence Organization Rule
 * @param userLicenseOrganizationRule The User's Licence Organization Rule
 * @param disableTitleValidation If we should disable the title validation check before generating the id
 * @returns The unique id for the userLicenceOrganizationRule
 */
export const useSelectedOrganizationIdentifier = (
    filteredOrganizationRules: FilteredOrganizationRules,
    userLicenseOrganizationRule: LicenceOrganisationRule,
    disableTitleValidation: boolean = false
): string => {
    const isValidTitle = useTitleValidation(filteredOrganizationRules, userLicenseOrganizationRule);

    const selectedOrganizationIdentifier = useMemo(
        () => {
            if (disableTitleValidation || isValidTitle)
                return SelectedOrganizationIdGenerator.generateId(userLicenseOrganizationRule);

            return "";
        },
        [userLicenseOrganizationRule, disableTitleValidation, isValidTitle]
    );

    return selectedOrganizationIdentifier;
};
